import React from 'react';
import PropTypes from 'prop-types';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import ManageGiftItemCard from 'Components/Order/ManageGiftItemCard';
import { toggleGiftModal } from 'Redux/ducks/modal';
import store from 'Redux/store';
import RedeemGiftShare from 'Components/Order/RedeemGiftShare';
import { supportUrl } from 'Config/lang';
import 'Components/Order/ManageGift.scss';


const ManageGift = ({
  gift,
  items,
  orderId,
  isCompleteOrder,
}) =>
  <React.Fragment>
    <div className="manage-gift">
      <h4>
        <FormattedMessage id="managegift.managegifts" defaultMessage="Manage Gift Order" />
      </h4>

      {isCompleteOrder &&
        <React.Fragment>
          {!gift.redeemed &&
            <p>
              <FormattedMessage
                id="managegift.revokeddisclaimer"
                defaultMessage="Revoking this gift order will return the order items back into your account. It will no longer be possible for the gift recipient to share or redeem the order."
              />
            </p>
          }

          <div className="order-table-container">
            <div className="order-table-column">
              <div className="column-title">
                <FormattedMessage id="managegift.recipient" defaultMessage="Recipient" />
              </div>
              <div className="column-cell">
                {gift.recipient_email}
                {gift.wishlist_display_name &&
                  <Link className="recipient-link" to={`/wishlist/${gift.wishlist_id}`}>
                    {gift.wishlist_display_name}
                  </Link>
                }
                {(!gift.recipient_email && !gift.wishlist_display_name) &&
                  <FormattedMessage id="managegift.nonspecified" defaultMessage="None Specified" />
                }
              </div>
            </div>
            <div className="order-table-column">
              <div className="column-title">
                <FormattedMessage id="managegift.deliverystatus" defaultMessage="Delivery Status" />
              </div>
              <div className="column-cell">
                {gift.redeemed &&
                  <FormattedMessage id="managegift.recipientaccepted" defaultMessage="Recipient Accepted" />
                }
                {!gift.redeemed &&
                  <FormattedMessage id="managegift.awaitingacceptance" defaultMessage="Awaiting Acceptance" />
                }
              </div>
            </div>

            {gift.scheduled_delivery_date &&
              <div className="order-table-column">
                <div className="column-title">
                  <FormattedMessage id="managegift.deliverydate" defaultMessage="Scheduled Delivery" />
                </div>
                <div className="column-cell">
                  <FormattedDate value={gift.scheduled_delivery_date} year="numeric" month="short" day="2-digit" />
                </div>
              </div>
            }

            {!gift.redeemed &&
              <div className="order-table-column">
                <div className="column-title">
                  <FormattedMessage id="managegift.actions" defaultMessage="Actions" />
                </div>
                <div className="column-cell">
                  <div className="action-buttons">
                    <button
                      className="btn btn-link btn-link-primary"
                      onClick={() => store.dispatch(toggleGiftModal({ giftOrder: gift, orderId, giftAction: 'edit', emailConfirmed: true }))}
                    >
                      <FormattedMessage id="managegift.edit" defaultMessage="Edit Gift" />
                    </button>
                    <button
                      className="btn btn-link btn-link-secondary"
                      onClick={() => store.dispatch(toggleGiftModal({ giftOrder: gift, orderId, giftAction: 'revoke', emailConfirmed: true }))}
                    >
                      <FormattedMessage id="managegift.revokegift" defaultMessage="Revoke" />
                    </button>
                  </div>
                </div>
              </div>
            }

          </div>
        </React.Fragment>
      }

      {!gift.redeemed && isCompleteOrder &&
        <div className="gift-sharing-container">
          <h4>
            <FormattedMessage id="managegift.shareyourgift" defaultMessage="Share Your Gift" />
          </h4>
          <p>
            <FormattedMessage
              id="managegift.sharegift.info"
              defaultMessage="Share your Fanatical gift with a friend, your own way! Simply copy and share your link below. Find out more about gifting in this {supportlink}."
              values={{
                supportlink: <a href={`${supportUrl()}/articles/360015776518`} target="_blank" rel="noopener noreferrer">
                  <FormattedMessage
                    id="managegift.info-extra.support-link"
                    defaultMessage="support article"
                  />
                </a>,
              }}
            />
          </p>
          <RedeemGiftShare code={gift.code} />
        </div>
      }

      {gift.personal_message &&
        <div className="gift-message-container">
          <h4 className="mb-3">
            <FormattedMessage id="managegift.giftmesssage" defaultMessage="Gift Message" />
          </h4>
          <div className="gift-message-box">
            {gift.personal_message}
          </div>
        </div>
      }

      <div className="gift-order-items-container">
        <h4 className="mb-3">
          <FormattedMessage id="managegift.order-items" defaultMessage="Order Items" />
        </h4>
        {items && items.length > 0 &&
          <div className="order-bundle-items-container">
            {items.map(item =>
              <ManageGiftItemCard item={item} key={Math.random()} />,
            )}
          </div>
        }
      </div>
    </div>
  </React.Fragment>;

ManageGift.propTypes = {
  gift: PropTypes.shape({}),
  items: PropTypes.arrayOf(PropTypes.object),
  orderId: PropTypes.string,
  isCompleteOrder: PropTypes.bool,
};

ManageGift.defaultProps = {
  gift: null,
  orderId: '',
  items: [],
  isCompleteOrder: false,
};

export default ManageGift;
